<div class="forbidden">
    <div class="fb-card">
        <div class="fb-icon"><i class="pi pi-lock"></i></div>
        <h1>No Access</h1>
        <p>You don't have permission to view this page.</p>
        <p class="muted">Please contact your administrator to get the required menu access.</p>
        <div class="fb-actions">
            <p-button label="Go to my dashboard" icon="pi pi-home" (onClick)="goHome()" />
            <p-button (onClick)="logout()" [disabled]="loading()" [outlined]="true" severity="secondary"
                [label]="loading() ? 'Signing out...' : 'Logout'"
                [icon]="loading() ? 'pi pi-spin pi-spinner' : 'pi pi-sign-out'" />
        </div>
    </div>
</div>
